import axios from 'axios';

// 创建axios对象
const service = axios.create({
  baseURL: 'http://www.deck.ne.jp/guardrail_cal_two', // [日本客户使用-旭兴进]
  // baseURL: 'https://www.smtcld.com/guardrail_cal_two', // 华为云
  // baseURL: 'http://192.168.40.16:9088/guardrail_cal_two',
  // baseURL: 'http://192.168.40.52:9188/guardrail_cal_two',
  //baseURL: 'http://192.168.40.13:9088/guardrail_cal_two',
  // baseURL: 'http://192.168.40.116:9188/guardrail_cal_two',
  // 请求超时时间
  //timeout: 6000,
  timeout: 6000000,
  // 是否跨域请求
  crossDomain: true
});

service.interceptors.request.use(
  (config) => {
    const token = window.sessionStorage.getItem('token');
    if (token) {
      config.headers.token = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default service;
